import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    getLpOffices,
    getLpOfficesClear,
} from "../../../redux/reports/actions";
import { SessionKeys } from "../../../utils/AppUtils";
import _ from "lodash";
import CONFIG from "../../../utils/config";
import { CircularProgressbar } from "react-circular-progressbar";
import { Spinner } from "react-bootstrap";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import NotFoundImage from "../../NewDesign/NotFound/NotFoundImage";

const OfficeSection = (props) => {

    const { mesg, section, isMobile, selectedCourseList, selectedProviderList,
        selectedLpList, selectedTeamMatesList, selectedOfficeList
        , check, selectedManagerCoachList, dateRange, statusArr } = props;

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const lpOfficesRes = useSelector((state) => state?.report?.lpOffices);
    const rea_ids = [];
    const office_ids = [];
    const lp_ids = [];
    const manager_ids = [];
    const [counter, setCounter] = useState(1);
    const [totalOffices, setTotalOffices] = useState([])
    const [overAllOfficesData, setOverAllOfficesData] = useState([]);

    const [selectedRea] = useState(
        location?.state?.selectedTeamMatesList
    );

    const [loadSpinner, setLoadSpinner] = useState(true)
    function setCount(counter, setCounter) {
        return setCounter(counter + 1);
    }
    useEffect(() => {
        selectedOfficeList?.forEach(function (obj) {
            office_ids.push(obj.office_id);
        });
        selectedTeamMatesList?.forEach(function (obj) {
            rea_ids.push(obj.user_id);
        });
        selectedLpList?.forEach(function (obj) {
            lp_ids.push(obj.id);
        });
        selectedManagerCoachList?.forEach(function (obj) {
            manager_ids.push(obj.id);
        })
    });
    useEffect(() => {
        dispatch(getLpOffices({
            module: 'getlPReportOffices',
            postData: {
                token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                office_ids: office_ids,
                rea_ids: rea_ids,
                limit: counter,
                entity_id: lp_ids,
                is_onboarding: check ? 1 : 0,
                manager_ids: manager_ids,
                date_range: dateRange,
                status: statusArr,
            }
        }))

    }, [dispatch])
    //LP Offices
    useEffect(() => {
        setCounter(1)
        setOverAllOfficesData([])
        return (() => {
            dispatch(getLpOfficesClear())
        })
    }, [])
    // console.log("officess", overAllOfficesData)
    useEffect(() => {
        if (!_.isEmpty(lpOfficesRes)) {
            setLoadSpinner(false)
            if (lpOfficesRes?.status === "success") {
                let allData = (lpOfficesRes?.payload?.payload?.offices);
                setTotalOffices(lpOfficesRes?.payload?.payload)
                let temparr = _.cloneDeep(overAllOfficesData)
                if (counter === 1) {
                    temparr = []
                }
                setOverAllOfficesData([...temparr, ...allData])
                getLpOfficesClear()
            }
        }
    }, [lpOfficesRes])
    return (
        <section className="offices-rpeort progress-box-report">
            <div className="container-pwc">
                <div className="row">
                    <div className="col-md-12">
                        <div className="progess-count-tiel">
                            Offices&nbsp;<strong>({totalOffices?.total_offices})</strong>
                        </div>
                    </div>
                </div>
                <div className="row mt-3">
                    {(overAllOfficesData !== undefined) && (overAllOfficesData !== "") && (!_.isEmpty(overAllOfficesData)) ? overAllOfficesData?.map((i, index) => {
                        return (
                            <>
                                <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-report" key={index}>
                                    <div className="reopor-box-progess">
                                        <div className="progess-profile d-flex">
                                            <div className="userprogress-details">
                                                <h5 className="user-tiele">{i?.office_name}</h5>
                                                <OverlayTrigger
                                                    key='bottom'
                                                    placement='bottom'
                                                    overlay={
                                                        <Tooltip id={`tooltip-bottom`}>
                                                            <div
                                                                style={{
                                                                    color: "white",
                                                                    backgroundColor: "transparent",
                                                                }}

                                                            >{i?.office_name}</div>
                                                        </Tooltip>
                                                    }
                                                >
                                                    <p >{i?.office_name}</p>
                                                </OverlayTrigger>
                                                {/* <p>{i?.office_address}</p> */}
                                            </div>
                                        </div>
                                        <hr />
                                        <div className="progress-details">
                                            <div className="progess-report">
                                                <div className="circlebox">
                                                    <CircularProgressbar value={i?.percentage} />
                                                </div>
                                                <div className="progess-text-repfot">
                                                    {`${i?.percentage}%`}
                                                    <div className="progespte">Progress</div>
                                                </div>
                                            </div>
                                            <div className="progess-count-show">
                                                <div className="learning-points">
                                                    <h5>Learning Points</h5>
                                                    <div className="learningc-countshow">
                                                        {i?.learning_points}
                                                    </div>
                                                </div>
                                                <div className="learning-points ">
                                                    <h5>Learning Hours</h5>
                                                    <div className="learningc-countshow">
                                                        {/* {(Math.floor(i?.learning_hrs)) > 0 ? `${Math.floor(i?.learning_hrs)}` : ""}
                            {Math.floor(i?.learning_hrs) > 1 ? "Hrs" : Math.floor(i?.learning_hrs) > 0 ? "Hr" : ""}{" "}
                            {(Math.ceil((i?.learning_hrs - Math.floor(i?.learning_hrs)) * 60)) > 0 ?
                              Math.ceil((i?.learning_hrs - Math.floor(i?.learning_hrs)) * 60) : ""}
                            {(Math.ceil((i?.learning_hrs - Math.floor(i?.learning_hrs)) * 60)) > 1 ? "Mins" : (Math.ceil((i?.learning_hrs - Math.floor(i?.learning_hrs)) * 60)) > 0 ? "Min" : i?.learning_hrs} */}
                                                        {/* {i?.learning_hrs_val} */}
                                                        <p
                                                            dangerouslySetInnerHTML={{
                                                                __html: i?.learning_hrs_val,
                                                            }}
                                                        ></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        );
                    }) :
                        <div className="col-md-12">
                            <div className="not-found mt-3">
                                <div className="interboxes">
                                    {/* <img src="/images/finwell-img/NoSearchResults.svg" alt="Not Found" /> */}
                                    <NotFoundImage />
                                    <p> {mesg}</p>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="col-md-12 mt-3">
                        <p className="text-center">
                            {overAllOfficesData?.length === 0 || (_.toNumber(totalOffices?.total_offices) === overAllOfficesData?.length) ? "" : (_.toNumber(totalOffices?.total_offices) < 4) ? "" :
                                <button
                                    type="button"
                                    id="number"
                                    className="btn btn-primary-complete"
                                    onClick={() => {
                                        setCount(counter, setCounter);
                                        setLoadSpinner(true);
                                    }
                                    }
                                >
                                    {(loadSpinner) ?
                                        <div className="d-flex justify-content-center w-100">
                                            <Spinner animation="border" />
                                        </div>
                                        : "Load More"}
                                </button>
                            }
                        </p>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default OfficeSection;